import { render, staticRenderFns } from "./AgreementSection.vue?vue&type=template&id=4e5c0741&scoped=true"
import script from "./AgreementSection.vue?vue&type=script&lang=js"
export * from "./AgreementSection.vue?vue&type=script&lang=js"
import style0 from "./AgreementSection.vue?vue&type=style&index=0&id=4e5c0741&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c0741",
  null
  
)

export default component.exports